const defaults = {
  maxStringInput: 50
};

export default defaults;
